export default [
	//线下采购列表
	{
		path: 'offline',
		name: 'm_purchase_offline',
		props: route => route.params,
		component: () => import('@/pages/purchase/offline_purchase_list')
	},
	//线上采购列表
	{
		path: 'online',
		name: 'm_purchase_online_order',
		props: route => route.params,
		component: () => import('@/pages/purchase/online_purchase_list')
	},
	//采购退货列表
	{
		path: 'return',
		name: 'm_purchase_online_return',
		props: route => route.params,
		component: () => import('@/pages/purchase/purchase_return_list')
	},
	//采购供应商列表
	{
		path: 'supplier',
		name: 'm_purchase_supplier',
		props: route => route.params,
		component: () => import('@/pages/purchase/purchase_supplier_list')
	},
	//背贴码管理列表
	{
		path: 'unique_code',
		name: 'm_product_unique_code',
		props: route => route.params,
		component: () => import('@/pages/product/product_unique_code_list')
	},
	//竞价堂采购
	{
		path: 'bidding',
		name: 'm_purchase_bidding_order',
		props: route => route.params,
		component: () => import('@/pages/purchase/bidding_purchase_list')
	},
	//竞价堂采购退货
	{
		path: 'bidding/return',
		name: 'm_purchase_bidding_return',
		props: route => route.params,
		component: () => import('@/pages/purchase/bidding_purchase_return_list')
	}
];
